var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sm:flex flex-grow justify-center w-full min-w-screen h-full bg-white sm:bg-gray-100 font-inter min-h-screen",class:{ 'items-center': _vm.$route.name !== 'projectVersionHistory' },attrs:{"id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }